enum EIcon {
	arrowDown = 'south',
	arrowUp = 'north',
	arrowLeft = 'west',
	arrowRight = 'east',
	twitter = 'twitter',
	telegram = 'telegram',
	discord = 'discord',
	check = 'check',
	wallet = 'wallet',
	email = 'email',
	chevronDown = 'keyboard_arrow_down',
	chevronLeft = 'keyboard_arrow_left',
	chevronRight = 'keyboard_arrow_right',
	chevronUp = 'keyboard_arrow_up',
	github = 'github',
	copy = 'content_copy',
	diamond = 'diamond',
	none = 'none',
	unset = 'unset',
	card = 'card',
	list = 'list',
	overview = 'overview',
	shieldWarning = 'shield_warning',
	status = 'status',
	sword = 'sword',
	tree = 'tree',
	avatar = 'avatar',
	campaign = 'campaign',
	character = 'character',
	devhub = 'dev_hub',
	economy = 'economy',
	inventory = 'inventory',
	journal = 'journal',
	overview2 = 'overview2',
	protocols = 'protocols',
	protocols2 = 'protocols2',
	quests2 = 'quests2',
	quill = 'quill',
	skillTree = 'skill_tree',
	staking = 'staking',
	techPrimitives = 'tech_primitives',
	theory = 'theory',
	refresh = 'refresh',
	weapon = 'weapon',
	weaponShield = 'weapon-shield',
	armor = 'armor',
	boots = 'boots',
	gloves = 'gloves',
	helmet = 'helmet',
	validationFailed = 'validation-fail',
	validationSuccess = 'validation-success',
	hashtag = 'hashtag',
	bag = 'bag',
	advancedDesignPatterns = 'advanced_design_patterns',
	advancedSecurity = 'advanced_security',
	dataAlgorithms = 'data_algorithms',
	designPatterns = 'design_patterns',
	ecosystems = 'ecosystems',
	history = 'history',
	lowLevelProgramming = 'low_level_programming',
	numberOfQuests = 'number_of_quests',
	security = 'security',
	skills = 'skills',
	techProtocols = 'tech_protocols',
	tools = 'tools',
	lightBulb = 'lightBulb',
	faq = 'faq',
	link = 'link',
	nodeguardians = 'nodeguardians',
	share = 'share',
	bulletpoints = 'bulletpoints',
	support = 'support',
	filter = 'filter',
	anvil = 'anvil',
	// new set
	// new @todo(integrate into strapi icons enum)
	cross = 'cross',
	settings = 'settings',
	trash = 'trash',
	login = 'login',
	logout = 'logout'
}

export { EIcon };
